export default "__VITE_ASSET__DeyMdWku__"